import { render, staticRenderFns } from "./Message_preview.vue?vue&type=template&id=607b14b0"
import script from "./Message_preview.vue?vue&type=script&lang=js"
export * from "./Message_preview.vue?vue&type=script&lang=js"
import style0 from "./Message_preview.vue?vue&type=style&index=0&id=607b14b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports